import { HmacSHA224 } from 'crypto-js'
import * as React from 'react'

import Accordion from 'react-bootstrap/Accordion'

export const BusinessCardReaderContent = ({ piwikVisitorId }) => {
  return (
    <>
      <div className={''}>
        <div className={'container py-6'}>
          <style>
            {`
                  .steps-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                  }

                  .steps-line {
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                    position: relative;
                  }

                  .steps-line::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 18px;
                    width: 4px;
                    background-color: #18c884;
                  }

                  .step {
                    display: flex;
                    align-items: flex-start;
                    gap: 20px;
                    position: relative;
                  }

                  .step-icon {
                    width: 40px!important;
                    height: 40px!important;
                    background-color: #fff;
                    border: 4px solid #18c884;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1;
                    box-sizing: border-box;
                    flex-shrink: 0;
                  }

                  .step-content {
                    max-width: 400px;
                  }

                  .step-content h4 {
                    margin: 0;
                    font-size: 18px;
                    color: #333;
                  }

                  .step-content p {
                    margin: 5px 0 0;
                    font-size: 14px;
                    color: #666;
                  }

                  .step:last-child {
                    background-color: #fff;
                  }
              `}
          </style>
          <h2 className="text-center mb-5">{'How It Works'}</h2>
          <div className="row justify-content-center g-5 mx-auto">
            <div className="col-auto d-flex justify-content-end">
              <video
                class="w-full shadow rounded-4 border border-5"
                autoPlay
                loop
                muted
                playsInline
                style={{ maxHeight: '520px' }}
              >
                <source
                  src="https://colibri-live.cdn.prismic.io/colibri-live/aCW22CdWJ-7kSJni_Yohn.iofreebusinesscardreaderdemo.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="col-12 col-lg-6">
              <div className="steps-container">
                <div className="steps-line">
                  <div className="step">
                    <div className="step-icon">
                      <img
                        src="https://images.prismic.io/colibri-live/691f4646-39df-42dd-a458-9f240f29c3e4_succ-purchase.png?auto=format,compress"
                        alt="Step 1"
                        height="20"
                        width="20"
                      />
                    </div>
                    <div className="step-content">
                      <h4>1. Take or Upload a Photo of a Card</h4>
                      <p>Capture the card image to start the process.</p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-icon">
                      <img
                        src="https://images.prismic.io/colibri-live/691f4646-39df-42dd-a458-9f240f29c3e4_succ-purchase.png?auto=format,compress"
                        alt="Step 2"
                        height="20"
                        width="20"
                      />
                    </div>
                    <div className="step-content">
                      <h4>2. Review the Output & Add Notes</h4>
                      <p>Check the scanned details and add personal notes.</p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-icon">
                      <img
                        src="https://images.prismic.io/colibri-live/691f4646-39df-42dd-a458-9f240f29c3e4_succ-purchase.png?auto=format,compress"
                        alt="Step 3"
                        height="20"
                        width="20"
                      />
                    </div>
                    <div className="step-content">
                      <h4>
                        3. Save to Contacts, Export as VCF/Text, or Add to CRM
                      </h4>
                      <p>Save the contact details in your preferred format.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*<div className="col">
              <div class="bg-white rounded overflow-hidden shadow w-auto">
                <div class="p-5">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="mb-0">1. Take or Upload a Photo of a Card</h3>
                    </div>
                    <div
                      class="d-flex align-items-center"
                      style={{ height: '1px', width: '1px' }}
                    >
                      <p
                        className="fw-bold"
                        style={{
                          lineHeight: '1px',
                          fontSize: '200px',
                          marginLeft: '-88px',
                          opacity: 0.05,
                        }}
                      >
                        1
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white rounded overflow-hidden shadow w-auto">
                <div class="p-5">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="mb-0">2. Review the Output & Add Notes</h3>
                    </div>
                    <div
                      class="d-flex align-items-center"
                      style={{ height: '1px', width: '1px' }}
                    >
                      <p
                        className="fw-bold"
                        style={{
                          lineHeight: '1px',
                          fontSize: '200px',
                          marginLeft: '-88px',
                          opacity: 0.05,
                        }}
                      >
                        2
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white rounded overflow-hidden shadow w-auto">
                <div class="p-5">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="mb-0">
                        3. Save to Contacts, Export as VCF/Text, or Add to CRM
                      </h3>
                    </div>
                    <div
                      class="d-flex align-items-center"
                      style={{ height: '1px', width: '1px' }}
                    >
                      <p
                        className="fw-bold"
                        style={{
                          lineHeight: '1px',
                          fontSize: '200px',
                          marginLeft: '-88px',
                          opacity: 0.05,
                        }}
                      >
                        3
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
      <div className="bg-light">
        <div className={'container py-6'}>
          <div className="row g-4">
            <div className="col-12 col-lg-4">
              <h2 className="text-center text-lg-start">{'Why Yohn.io?'}</h2>
              <h5 className="text-secondary">
                {
                  'From paper to a ready-to-use contact — in just one scan, no apps or signups needed.'
                }
              </h5>
            </div>
            <div className="col-12 col-lg-4">
              <div className="bg-white rounded-4 p-4 h-100">
                <img
                  src="https://colibri-live.cdn.prismic.io/colibri-live/aBn0fvIqRLdaB5wf_icon-bc-scanning.svg"
                  class="mb-4 mb-lg-5"
                  height="64"
                />
                <h4>Instant Contact Creation</h4>
                <p className="mb-0">
                  Scan business cards and save them as smartphone contacts,
                  plain text, or import directly into your CRM.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="bg-white rounded-4 p-4 h-100">
                <img
                  src="https://colibri-live.cdn.prismic.io/colibri-live/aBn1jfIqRLdaB5xT_icon-lock.svg"
                  class="mb-4 mb-lg-5"
                  height="64"
                />
                <h4>Private & Secure</h4>
                <p className="mb-0">
                  Your data stays yours — Yohn is 100% GDPR-compliant and
                  doesn’t sell data to any third parties.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="bg-white rounded-4 p-4 h-100">
                <img
                  src="https://colibri-live.cdn.prismic.io/colibri-live/aBn0fPIqRLdaB5wd_icon-user-laptop.svg"
                  class="mb-4 mb-lg-5"
                  height="64"
                />
                <h4>App-Free User Experience</h4>
                <p className="mb-0">
                  No app to install, no signup required — just scan straight
                  from your browser.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="bg-white rounded-4 p-4 h-100">
                <img
                  src="https://colibri-live.cdn.prismic.io/colibri-live/aBn0f_IqRLdaB5wh_icon-bulb.svg"
                  class="mb-4 mb-lg-5"
                  height="64"
                />
                <h4>Smart Notes</h4>
                <p className="mb-0">
                  Add personal notes to each card, making it easier to organize
                  and remember your connections.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="bg-white rounded-4 p-4 h-100">
                <img
                  src="https://colibri-live.cdn.prismic.io/colibri-live/aBn0gPIqRLdaB5wj_icon-accuracy.svg"
                  class="mb-4 mb-lg-5"
                  height="64"
                />
                <h4>Unbeatable Accuracy</h4>
                <p className="mb-0">
                  99%+ precision in recognizing and mapping contact details.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-light">
        <div className={'container py-6 border-top'}>
          <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center ">
            <h3 className="text-center mb-0 me-1">
              See what our customers say about us:
            </h3>
            <a
              href="https://www.google.com/maps/place/Yohn.io/@48.7098336,8.9975985,17z/data=!3m1!5s0x4799dfc9f06a94f9:0xdaba0d45c148c52d!4m8!3m7!1s0x4799dfce45060f4f:0xeb708882404761f3!8m2!3d48.7098301!4d9.0001734!9m1!1b1!16s%2Fg%2F11kq5pk3xr?entry=ttu"
              target="_blank"
            >
              <img
                src="https://images.prismic.io/colibri-live/aBoGP_IqRLdaB5-w_google-reviews.png?auto=format,compress"
                alt="Google reviews"
                class="ms-3 img-fluid"
                loading="lazy"
                style={{ height: '120px' }}
              />
            </a>
          </div>
        </div>
      </div>
      {/*<div className="">
        <div className={'container py-6'}>
          <div className="d-flex justify-content-center align-items-center ">
            <h3 className="text-center mb-0 me-1">
              See what our customers say about us:
            </h3>
            <a
              href="https://www.google.com/maps/place/Yohn.io/@48.7098336,8.9975985,17z/data=!3m1!5s0x4799dfc9f06a94f9:0xdaba0d45c148c52d!4m8!3m7!1s0x4799dfce45060f4f:0xeb708882404761f3!8m2!3d48.7098301!4d9.0001734!9m1!1b1!16s%2Fg%2F11kq5pk3xr?entry=ttu"
              target="_blank"
            >
              <img
                src="https://images.prismic.io/colibri-live/aBoELvIqRLdaB58Z_google-review.png?auto=format,compress"
                alt="Google reviews"
                class="ms-3 img-fluid"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>*/}
      {/*<div className="">
        <div className={'container py-6'}>
          <h2 className="text-center mb-5">{'Features'}</h2>
          <div className="row g-4">
            <div className="col-12 col-lg-6 col-xl-4">
              <div className="bg-light rounded-4 p-4 h-100">
                <h4>Scan Business Cards Instantly</h4>
                <p>
                  Capture contact details with a quick photo — no manual typing
                  needed.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-4">
              <div className="bg-light rounded-4 p-4 h-100">
                <h4>Add Personal Notes</h4>
                <p>
                  Attach notes to any contact — perfect for remembering where
                  and how you met.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-3">
              <div className="bg-light rounded-4 p-4 h-100">
                <h4>Export as Plain Text</h4>
                <p>
                  Save card data as plain text for easy access, copying, or
                  sharing.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-3">
              <div className="bg-light rounded-4 p-4 h-100">
                <h4>Save Directly to Contacts</h4>
                <p>
                  Add scanned business cards to your smartphone contacts with a
                  single tap.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-3">
              <div className="bg-light rounded-4 p-4 h-100">
                <h4>Export to Your CRM</h4>
                <p>
                  Seamlessly import scanned contacts into your CRM system for
                  easy follow-up.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-3">
              <div className="bg-light rounded-4 p-4 h-100">
                <h4>Send to Your Email</h4>
                <p>
                  Send the card image, contact file (.VCF), and text data to
                  your email for safekeeping or later use.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>*/}
      <div className="">
        <div className={'container pb-6 pt-5'}>
          <div className="row g-4">
            <div className="col-12 col-lg-3">
              <h2 className="text-center text-lg-start">{'Features'}</h2>
              <h5 className="text-secondary">
                {
                  'The easiest way to digitize business cards and keep your contacts close.'
                }
              </h5>
            </div>
            <div className="col-12 col-lg-12 col-xl-9 row g-4 mt-0 interactive-transition">
              <style>
                {/*`
                  .interactive-transition .bg-light {
                    transition: background-color 0.6s ease, color 0.3s ease;
                  }
                  .interactive-transition .bg-light:hover {
                    background-color: #18c884!important;
                    color: #fff;
                    cursor: pointer;
                  }
                `*/}
              </style>
              <div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnXS_IqRLdaB5a9_icon-phone-success.svg"
                    class="mb-4 mb-lg-5"
                    height="64"
                  />
                  <h4>Scan Business Cards Instantly</h4>
                  <p>
                    Capture contact details with a quick photo — no manual
                    typing needed.
                  </p>
                </div>
              </div>
              {/*<div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnXTPIqRLdaB5a__icon-contact.svg"
                    class="mb-4 mb-lg-5"
                    height="64"
                  />
                  <h4>Share Your Own Digital Card</h4>
                  <p>
                    Create a digital business card for Apple or Google Wallet
                    and share it via a simple QR code scan.
                  </p>
                </div>
              </div>*/}
              <div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnUPvIqRLdaB5Zg_icon-notes.svg"
                    class="mb-4 mb-lg-5"
                    height="64"
                  />
                  <h4>Add Personal Notes</h4>
                  <p>
                    Attach notes to any contact — perfect for remembering where
                    and how you met.
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnU0fIqRLdaB5Zw_icon-plain-text.svg"
                    class="mb-4 mb-lg-5"
                    height="64"
                  />
                  <h4>Export as Plain Text</h4>
                  <p>
                    Save card data as plain text for easy access, copying, or
                    sharing.
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnTGfIqRLdaB5Yz_icon-add-contact.svg"
                    class="mb-4 mb-lg-5"
                    height="60"
                  />
                  <h4>Save Directly to Contacts</h4>
                  <p>
                    Add scanned business cards to your smartphone contacts with
                    a single tap.
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnXSvIqRLdaB5a8_icon-crm.svg"
                    class="mb-4 mb-lg-5"
                    height="64"
                  />
                  <h4>Export to Your CRM</h4>
                  <p>
                    Seamlessly import scanned contacts into your CRM system for
                    easy follow-up.
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="bg-light rounded-4 p-4 h-100">
                  <img
                    src="https://colibri-live.cdn.prismic.io/colibri-live/aBnVafIqRLdaB5Z7_icon-email-contact.svg"
                    class="mb-4 mb-lg-5"
                    height="64"
                  />
                  <h4>Send to Your Email</h4>
                  <p>
                    Send the card image, contact file (.VCF), and text data to
                    your email for safekeeping or later use.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={'bg-light'}>
        <div className={'container py-6'}>
          <h2 className="text-center mb-5">{'Use Cases'}</h2>
          <div className="row g-4">
            {/*<div class="col-12 col-lg-7 px-0">
              <div class="row">
                <div class="col-12 col-lg-6 d-flex flex-column justify-content-center px-2 px-lg-3 order-lg-2">
                  <div class="mb-4 bg-white rounded-4 p-4">
                    <h4>After trade fairs, conferences & networking events</h4>
                    <p className="mb-0">
                      Quickly scan and save business cards from expos and events
                      and never lose a valuable connection again.
                    </p>
                  </div>
                  <div class="bg-white rounded-4 p-4">
                    <h4>After meetings with potential customers</h4>
                    <p className="mb-0">
                      Scan cards, add personal notes about prospects and their
                      needs, and import contacts into your CRM to support your
                      sales team.
                    </p>
                  </div>
                </div>
                <div class="col-12 col-lg-6 d-flex flex-column justify-content-center px-2 px-lg-3 mt-4 mt-lg-0">
                  <div class="bg-white rounded-4 p-4">
                    <h4>
                      When organizing old business cards you've collected over
                      time
                    </h4>
                    <p className="mb-0">
                      Finally digitize that stack of old business cards lying in
                      your office and put it to use.
                    </p>
                  </div>
                </div>
              </div>
            </div>*/}
            <div className="col-12 col-lg-6">
              <div className="bg-white rounded-4 p-4">
                <h4>After trade fairs, conferences & networking events</h4>
                <p className="mb-0">
                  Quickly scan and save business cards from expos and events and
                  never lose a valuable connection again.
                </p>
              </div>
              <div className="bg-white rounded-4 p-4 mt-4">
                <h4>After meetings with potential customers</h4>
                <p className="mb-0">
                  Scan cards, add personal notes about prospects and their
                  needs, and import contacts into your CRM to support your sales
                  team.
                </p>
              </div>
              <div className="bg-white rounded-4 p-4 mt-4">
                <h4>
                  When organizing old business cards you've collected over time
                </h4>
                <p className="mb-0">
                  Finally digitize that stack of old business cards lying in
                  your office and put it to use.
                </p>
              </div>
            </div>
            <div class="col-12 col-lg-6 h-100">
              <img
                src="https://images.prismic.io/colibri-live/aBnfVfIqRLdaB5iB_business-partners.jpg?auto=format,compress"
                class="rounded-4"
                style={{ objectFit: 'contain', maxWidth: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={'container py-6'}>
        <style>
          {`
            .accordion {
              display: flex;
              flex-direction: column;
              gap: 16px;
            }
            .accordion-item {
              background-color: #f8f9fb;
              border: 0px;
              border-radius: 8px;
            }
            .accordion-button {
              box-shadow: none!important;
              background-color: transparent;
            }
            .accordion-button:focus {
              box-shadow: none;
            }
            .accordion-button:not(.collapsed) {
              color: currentcolor;
              background-color: #f8f9fb;
            }
            .accordion-body {
              //background-color: #ffffff;
              padding-top: 0px;
            }
          `}
        </style>
        <div className="row g-5">
          <img
            src="https://images.prismic.io/colibri-live/027f450c-cdad-484d-929b-5e40c81f8f2d_card-apple-google.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max"
            className="col-12 col-lg-5 order-2 order-lg-1"
            style={{ objectFit: 'contain' }}
          />

          <div className="col-12 col-lg-7 order-1 order-lg-2">
            <h2 className="text-center">{'Frequently Asked Questions'}</h2>
            <p className="text-center">
              {'No confusion, just answers — everything you need to know.'}
            </p>
            <div className="mt-5">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header as="h3">
                    <span className="h5 mb-0">{`Is Yohn.io's business card scanner and reader really free?`}</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {`Yes! You can scan business cards for free each day under our fair-use policy. `}
                    <a
                      href={`https://yo.hn/getpremiumcard?checkout[custom][visitor_id]=${piwikVisitorId}`}
                      target="_blank"
                    >
                      Upgrade to a premium digital business card for just
                      $1.49/month
                    </a>
                    {` to enjoy increased scanning limits, as well as the option to email scanned card images directly to yourself. Yohn+, Corporate, and Enterprise subscribers receive unlimited scans, CRM integration, and all premium features.`}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header as="h3">
                    <span className="h5 mb-0">{'Do I need an app?'}</span>
                  </Accordion.Header>
                  <Accordion.Body>{`No apps needed! Yohn.io is 100% web-based — no downloads or installations required.`}</Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header as="h3">
                    <span className="h5 mb-0">{'Is my data safe?'}</span>
                  </Accordion.Header>
                  <Accordion.Body>{`Absolutely. Your data stays private — we never sell your information or the card data you scan.
Yohn.io is fully GDPR-compliant and uses Amazon Web Services, certified to ISO/IEC 27001:2022, 27017:2015, and 27018:2019 standards, as its infrastructure provider.`}</Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header as="h3">
                    <span className="h5 mb-0">
                      {'How do I add a note to a scanned business card?'}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>{`After scanning, simply enter your note in the "Note" field on the review screen.
The note will be saved along with the contact — whether you export it as text, .VCF, or into your CRM.`}</Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header as="h3">
                    <span className="h5 mb-0">
                      {
                        'Will you contact the people whose business cards I scan?'
                      }
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>{`Never.
Yohn.io will not contact or interact with the people whose cards you scan.`}</Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      {/*<div
        style={{
          background: 'linear-gradient(90deg, #FFC0CB 50%, #00FFFF 50%)',
        }}
      >
        <style>
          {`
            .accordion {
              display: flex;
              flex-direction: column;
              gap: 16px;
            }
            .accordion-item {
              background-color: #f8f9fb;
              border: 0px;
              border-radius: 8px;
            }
            .accordion-button {
              box-shadow: none!important;
              background-color: transparent;
            }
            .accordion-button:focus {
              box-shadow: none;
            }
            .accordion-button:not(.collapsed) {
              background-color: #f8f9fb;
            }
            .accordion-body {
              //background-color: #ffffff;
              padding-top: 0px;
            }
          `}
        </style>
        <style>
          {/*`.accordion-button:not(.collapsed) {
            color: currentcolor;
            border-left: 6px solid #18c884 !important;
            background-color: #f8f9fb;
          }
          .accordion-button:focus {
            box-shadow: none;
        }`
        </style>
        <div className={'container py-0 py-lg-5 px-0 px-lg-3'}>
          <div className="">
            <div className="col-12 col-lg-8 ms-auto">
              <div className="bg-white px-3 px-lg-5 py-5 rounded-4">
                <h2 className="text-center">{'Frequently Asked Questions'}</h2>
                <p>
                  {
                    'Get clear and concise answers to your questions. Explore our FAQ section for quick support and guidance.'
                  }
                </p>
                <div className="mt-5">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header as="h3">
                        <span className="h5 mb-0">{`Is Yohn.io's business card scanner and reader really free?`}</span>
                      </Accordion.Header>
                      <Accordion.Body>{`Yes! You can scan business cards for free each day under our fair-use policy. `}
                    <a
                      href={`https://yo.hn/getpremiumcard?checkout[custom][visitor_id]=${piwikVisitorId}`}
                      target="_blank"
                    >
                      Upgrade to a premium digital business card for just
                      $1.49/month
                    </a>
                    {` to enjoy increased scanning limits, as well as the option to email scanned card images directly to yourself. Yohn+, Corporate, and Enterprise subscribers receive unlimited scans, CRM integration, and all premium features.`}</Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header as="h3">
                        <span className="h5 mb-0">{'Do I need an app?'}</span>
                      </Accordion.Header>
                      <Accordion.Body>{`No apps needed! Yohn.io is 100% web-based — no downloads or installations required.`}</Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header as="h3">
                        <span className="h5 mb-0">{'Is my data safe?'}</span>
                      </Accordion.Header>
                      <Accordion.Body>{`Absolutely. Your data stays private — we never sell your information or the card data you scan.
Yohn.io is fully GDPR-compliant and uses Amazon Web Services, certified to ISO/IEC 27001:2022, 27017:2015, and 27018:2019 standards, as its infrastructure provider.`}</Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header as="h3">
                        <span className="h5 mb-0">
                          {'How do I add a note to a scanned business card?'}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>{`After scanning, simply enter your note in the "Note" field on the review screen.
The note will be saved along with the contact — whether you export it as text, .VCF, or into your CRM.`}</Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header as="h3">
                        <span className="h5 mb-0">
                          {
                            'Will you contact the people whose business cards I scan?'
                          }
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>{`Never.
Yohn.io will not contact or interact with the people whose cards you scan.`}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>*/}
    </>
  )
}
